// extracted by mini-css-extract-plugin
export var attachmentContainer = "_q5-0";
export var fileList = "_q5-2";
export var removeFileButton = "_q5-1";